import { forwardRef } from 'react';
import { Search, X } from 'lucide-react';

const SearchInput = forwardRef(function SearchInput({ value, onChange, onClear, placeholder = 'Buscar...', ...props }, ref) {
  return (
    <div className="relative">
      <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-content-muted" aria-hidden="true" />
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="h-10 w-full rounded-control border bg-white pl-9 pr-9 text-sm text-content-primary shadow-xs outline-none transition placeholder:text-slate-400 focus:border-primary-500 focus:shadow-focus"
        {...props}
      />
      {value && onClear && (
        <button type="button" onClick={onClear} className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-content-muted hover:bg-slate-100 hover:text-content-primary" aria-label="Limpiar búsqueda">
          <X className="size-4" />
        </button>
      )}
    </div>
  );
});

export default SearchInput;
